import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import {
  FormLabelItem,
  FormRequired,
} from '../stylesheets/Form.style';

class FormLabel extends PureComponent {
  render() {
    const {
      label, required, icon, dataTip, htmlFor,
    } = this.props;
    return (
      <FormLabelItem htmlFor={htmlFor}>
        {label}
        {required && <FormRequired>*</FormRequired>}
        {icon && dataTip && (
          <Tooltip
            title={dataTip}
            placement="right"
            arrow
            leaveDelay={200}
          >
            <i className={icon} role="img" aria-label={dataTip} tabIndex={0} />
          </Tooltip>
        )}
        {icon && !dataTip && <i className={icon} />}
      </FormLabelItem>
    );
  }
}

FormLabel.propTypes = {
  required: PropTypes.bool,
  label: PropTypes.string,
  icon: PropTypes.string,
  dataTip: PropTypes.string,
  htmlFor: PropTypes.string,
};

FormLabel.defaultProps = {
  required: false,
  label: '',
  icon: '',
  dataTip: '',
  htmlFor: undefined,
};

export default FormLabel;
